import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-custom-number-box-data-grid',
  templateUrl: './custom-number-box-data-grid.component.html',
  styleUrls: ['./custom-number-box-data-grid.component.css']
})
export class CustomNumberBoxDataGridComponent implements OnInit {
  @Input('value') public value: number;
  @Output() valueChange = new EventEmitter<number>();

  @Input('width') width: number;
  @Input() readOnly: boolean = false;

  @Input() cell: any;

  constructor(private translateService: TranslateService) {
  }

  ngOnInit(): void {
    // this.id = 0;
  }

  valueChanged(e) {
    if (!!this.cell) {
      this.cell.setValue(this.value);
    }

    this.valueChange.emit(this.value);
  }

}
